__turbopack_context__.v({
  "actionCell": "Table-module__DdULZW__actionCell",
  "bodyRow": "Table-module__DdULZW__bodyRow",
  "bodyRowExpanded": "Table-module__DdULZW__bodyRowExpanded",
  "cell": "Table-module__DdULZW__cell",
  "glassSurface": "Table-module__DdULZW__glassSurface",
  "gridRow": "Table-module__DdULZW__gridRow",
  "headerRow": "Table-module__DdULZW__headerRow",
  "pageInset": "Table-module__DdULZW__pageInset",
  "sheetSurface": "Table-module__DdULZW__sheetSurface",
  "tableContainer": "Table-module__DdULZW__tableContainer",
});
